// extracted by mini-css-extract-plugin
export default {"loadingAnimation":"loadingAnimation___X9OIl","loading":"loading___GGrJn"};